import {Typography, TypographyProps} from '@mui/material'
import React from 'react'

export const SectionTitle: React.FC<TypographyProps> = (props) => (
  <Typography variant="h2" ml={3} mb={{xs: 2, md: 3}} mt={{xs: 3, md: 4}} {...props} />
)
